import { render, staticRenderFns } from "./StartupByVdDialog.vue?vue&type=template&id=cebc7bb2&scoped=true"
import script from "./StartupByVdDialog.vue?vue&type=script&lang=ts"
export * from "./StartupByVdDialog.vue?vue&type=script&lang=ts"
import style0 from "./StartupByVdDialog.vue?vue&type=style&index=0&id=cebc7bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebc7bb2",
  null
  
)

export default component.exports